import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import FilterTag from "../FilterTag";
import { Query } from "react-apollo";
import gql from "graphql-tag";

const authorQuery = gql`
  query Author($id: ID!) {
    node(id: $id) {
      id
      ... on User {
        name
      }
    }
  }
`;

export default class AuthorFilter extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  };

  render() {
    const { onClick, type, value } = this.props;

    return (
      <Query
        query={authorQuery}
        variables={{
          id: value,
        }}
      >
        {({ loading, error, data }) => (
          <FilterTag
            type={type}
            loading={loading}
            onClick={onClick}
            value={(data && data.node && data.node.name) || value}
          />
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filter/AuthorFilter/index.js